import { createReducer } from 'redux-act';

import {
  loadGiftTypesRequest,
  loadGiftTypesSuccess,
  loadGiftTypesFail,
  loadCategoriesRequest,
  loadCategoriesSuccess,
  loadCategoriesFail,
  loadBrandsRequest,
  loadBrandsSuccess,
  loadBrandsFail,
  resetFilters,
} from './filters.actions';
import { IFilter, IServerFilterOption } from './filters.types';

export interface IFiltersState {
  giftTypes: IFilter;
  categories: IFilter;
  brands: IFilter;
}

export const initialState: IFiltersState = {
  giftTypes: {
    isLoading: false,
    isLoaded: false,
    items: [],
  },
  categories: {
    isLoading: false,
    isLoaded: false,
    items: [],
  },
  brands: {
    isLoading: false,
    isLoaded: false,
    items: [],
  },
};

const LOADING_START = { isLoading: true, isLoaded: false };
const LOADING_SUCCESS = { isLoading: false, isLoaded: true };
const LOADING_FAIL = { isLoading: false, isLoaded: false };

const reducer = createReducer<IFiltersState>({}, initialState);

const transformFilterItems = (items: IServerFilterOption[]) =>
  items.map(({ id, label, productsCount }) => ({ id, label, count: productsCount }));

reducer
  .on(loadGiftTypesRequest, state => ({
    ...state,
    giftTypes: {
      ...state.giftTypes,
      ...LOADING_START,
    },
  }))
  .on(loadGiftTypesSuccess, (state, payload) => ({
    ...state,
    giftTypes: {
      ...LOADING_SUCCESS,
      items: transformFilterItems(payload),
    },
  }))
  .on(loadGiftTypesFail, state => ({
    ...state,
    giftTypes: {
      ...state.giftTypes,
      ...LOADING_FAIL,
    },
  }));

reducer
  .on(loadCategoriesRequest, state => ({
    ...state,
    categories: {
      ...state.categories,
      ...LOADING_START,
    },
  }))
  .on(loadCategoriesSuccess, (state, payload) => ({
    ...state,
    categories: {
      ...LOADING_SUCCESS,
      items: transformFilterItems(payload),
    },
  }))
  .on(loadCategoriesFail, state => ({
    ...state,
    categories: {
      ...state.categories,
      ...LOADING_FAIL,
    },
  }));

reducer
  .on(loadBrandsRequest, state => ({
    ...state,
    brands: {
      ...state.brands,
      ...LOADING_START,
    },
  }))
  .on(loadBrandsSuccess, (state, payload) => ({
    ...state,
    brands: {
      ...LOADING_SUCCESS,
      items: transformFilterItems(payload),
    },
  }))
  .on(loadBrandsFail, state => ({
    ...state,
    brands: {
      ...state.brands,
      ...LOADING_FAIL,
    },
  }));

reducer.on(resetFilters, state => ({
  ...state,
  giftTypes: {
    ...initialState.giftTypes,
  },
  categories: {
    ...initialState.categories,
  },
  brands: {
    ...initialState.brands,
  },
}));

export default reducer;
